import { observable, computed, action, when } from "mobx";
import {PATH_PORTALE} from '../config/portale-config';

class ErroreStore {

  constructor(rootStore) {
    this.rootStore = rootStore
    this.service = rootStore.service   
   
  }
  
  @observable error_code = ""

  @action
  ripristina() {  
     
      console.log("eseguo redirect verso la home del portale "+PATH_PORTALE)
      window.location.href = `${ process.env.CONTEXT_PATH }/home`
     
  }
 
}

export default ErroreStore;